/* eslint-disable eqeqeq */
import { useState } from "react";
import { useSelector } from "react-redux";
import { getUrlQuerysection } from "../../../../helpers";
import { useGetReturnRequestsList } from "../../../../hooks/api/queries/useInventory";
import { useUrlSearch } from "../../../../hooks/useUrlSearch";
import { returnStatusTabs } from "../../../../localdata";

const useReturns = () => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const queries = getUrlQuerysection();
  const [isReturn, setIsReturn] = useState(false);
  const {
    search,
    gotoPage,
    filterByStoreId,
    filterByDate,
    filterBySearch,
    filterByKey,
  } = useUrlSearch();

  const [startDate] = useState(search.get("start_date"));
  const [endDate] = useState(search.get("end_date"));

  const {
    data: returnRequestsData,
    isLoading: isLoadingReturns,
    refetch: handleFetchReturns,
  } = useGetReturnRequestsList({ queries });

  const returns = returnRequestsData?.data || [];
  const metaDetails = returnRequestsData?.meta || {};
  const pendingCount = metaDetails?.total_in_review || 0;

  return {
    storeList,
    isLoadingReturns,
    returns,
    metaDetails,
    isReturn,
    search,
    setIsReturn,
    gotoPage,
    filterByStoreId,
    filterByDate,
    filterBySearch,
    filterByKey,
    handleFetchReturns,
    startDate,
    endDate,
    returnStatusTabs,
    pendingCount,
  };
};

export default useReturns;
